import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  apiKey,
  apiPassword,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey, apiPassword] as const

export type cllqCredType = (typeof credentialTypes)[number]
export const cllqDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const cllq: CarrierDef<cllqCredType> = {
  name: 'Coyote Logistics',
  scac: 'cllq',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['api-password', 'apiPassword'],
  ],
  engineLayers: ['rating', 'bol', 'pickup', 'tracking', 'documents'],
  documentTypes: cllqDocumentTypes,
}
